import { useState, useEffect } from 'react'
import QuestionItem from 'containers/Examination/Presentation/QuestionItem'

const QuestionSlide = ({questions, onAnswerSelect}) => {

  const [answers, setAnswers] = useState([])

  const handleAnswerSelect = (question, answer) => {
    let newAnswer = answers.filter((a) => a.id !== question)

    setAnswers([...newAnswer, {
      id: question,
      answer: answer
    }])
  }

  useEffect(() => {
    onAnswerSelect(answers)
  }, [answers])

  useEffect(() => {
    if (questions.length > 0) {
      let answers = questions.map((q) => {
        return {
          id: q.id,
          answer: null
        }
      })

      setAnswers(answers)
    }
  }, [questions])

  return (
    <>
      {questions.length > 0 && questions.map((question) => <>
        <QuestionItem key={question.id} question={question} onAnswerSelect={handleAnswerSelect} />
      </>)}
    </>
  )
}

export default QuestionSlide